import * as Yup from 'yup';

const ChargesFormValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Name is required')
    .min(3, 'Name must be at least 3 characters long')
    .max(50, 'Name cannot be longer than 50 characters'),
  base_amount: Yup.number()
    .required('Base amount is required')
    .moreThan(0, 'Base amount must be more than zero'),
  gst: Yup.number()
    .required('GST is required')
    .min(0, 'GST cannot be ne gative')
    .max(100, 'GST cannot be more than 100'),
  total_amount: Yup.number()
    .required('Total amount is required')
    .moreThan(0, 'Total amount must be more than zero'),
  type: Yup.string().required('Type is required'),
});

export { ChargesFormValidationSchema };
